<template>
	<vue-scroll>
		<div id="page-contacts" class="page-contacts flex column scrollable only-y mb-20"
			v-show="userPermissionsFilter.admin" v-loading="pageLoading" :element-loading-text="loadingText"
			element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
			<resize-observer @notify="__resizeHanlder" />
			<div class="contacts-root box grow flex gaps justify-center" :class="contactsClass">

				<div class="contacts-list box grow scrollable only-y">
					<!-- <div v-for="c in usersFiltered" :key="c.emailAddress" class="flex contact" @click="openDialog(c)"> -->
					<div v-for="c in usersFiltered" :key="c.emailAddress" class="flex contact"
						@click="GoToUpdateUser(c.userID, $event)">
						<div class="star align-vertical p-10 fs-22">
							<i class="mdi mdi-checkbox-marked-circle align-vertical-middle" v-if="c.active"></i>
							<i class="mdi mdi-checkbox-blank-circle-outline align-vertical-middle" v-if="!c.active"></i>
						</div>
						<div class="avatar align-vertical">
							<img :src="imagePlaceholder" class="align-vertical-middle" alt="user avatar">
						</div>
						<div class="info box grow flex">
							<div class="name box grow flex column justify-center p-10">
								<div class="fullname fs-18"><strong>{{ c.fullName }}</strong></div>

								<div class="phone fs-14 secondary-text">
									{{ c.phoneNumber }}
								</div>
								<div class="email fs-14 secondary-text accent-text">{{ c.email }}</div>
							</div>
							<div class="phone align-vertical p-10"><span class="align-vertical-middle">{{ c.phoneNumber
									}}</span></div>
						</div>
					</div>
				</div>
			</div>

			<el-dialog :show-close="true" :custom-class="'user-dialog'" :visible="dialogFormVisible"
				@close="closeDialog" :before-close="handleClose" v-if="userPermissionsFilter.approveusers">
				<div class="avatar-box">
					<img :src="imagePlaceholder" alt="user avatar">
					<div class="star" @click="checkActive">
						<i class="mdi mdi-checkbox-marked-circle align-vertical-middle" v-if="userdata.active"></i>
						<i class="mdi mdi-checkbox-blank-circle-outline align-vertical-middle"
							v-if="!userdata.active"></i>
					</div>
				</div>
				<div class="form-box">
					<div class="row">
						<div class="row">
							<div class="col col-md-12">
								<!--<strong>Customer ID</strong>
										<el-input placeholder="Customer ID" v-model="userdata.customerNumber" name="customerNumber" data-vv-as="customerNumber" :readonly="true"></el-input>
										<transition name="fade"><span class="danger-text">{{ errors.first('customerNumber') }}</span></transition>-->
								<strong>User ID</strong>
								<el-input placeholder="User ID" v-model="userdata.userID" name="userID"
									v-validate="'required'" data-vv-as="userID" :readonly="true"></el-input>
								<transition name="fade"><span class="danger-text">{{ errors.first('userID') }}</span>
								</transition>
							</div>
						</div>
						<div class="row mt-12">
							<div class="col col-md-12">
								<strong>Date Registered</strong>
								<el-input placeholder="Date Registered" v-model="userdata.createdOn" :readonly="true"
									name="createdOn" v-validate="'required'" data-vv-as="createdOn"></el-input>
								<transition name="fade"><span class="danger-text">{{ errors.first('createdOn') }}</span>
								</transition>
							</div>
						</div>
						<div class="row mt-12">
							<div class="col col-md-12">
								<strong>Full Name</strong>
								<el-input placeholder="FullName" v-model="userdata.fullName" :readonly="false"
									@change="propertyChanged" name="fullName" v-validate="'required'"
									data-vv-as="fullName"></el-input>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('fullName') }}</span>
								</transition>
							</div>
						</div>
						<div class="row mt-12">
							<div class="col col-md-12">
								<strong>Phone Number</strong>
								<el-input placeholder="phoneNumber" :maxlength="12" v-model="userdata.phoneNumber"
									:readonly="false" @change="propertyChanged" name="phoneNumber"
									v-validate="'required'" data-vv-as="phoneNumber"
									v-on:blur="updatePhoneNo"></el-input>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('phoneNumber') }}</span>
								</transition>
							</div>
						</div>
						<div class="row mt-12">
							<div class="col col-md-12">
								<strong>Nationality</strong>
								<el-input placeholder="Nationality" v-model="userdata.nationality" :readonly="true"
									@change="propertyChanged" name="nationality" v-validate="'required'"
									data-vv-as="nationality"></el-input>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('nationality') }}</span>
								</transition>
							</div>
						</div>

						<div class="row mt-12">
							<div class="col col-md-12">
								<strong>Date of Birth</strong>
								<el-input placeholder="DOB" v-model="userdata.dob" :readonly="readOnlyMode"
									@change="propertyChanged" name="dob" v-validate="'required'"
									data-vv-as="dob"></el-input>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('dob') }}</span>
								</transition>
							</div>
						</div>

						<div class="row mt-12">
							<div class="col col-md-12">
								<strong>ID Number</strong>
								<el-input placeholder="ID Number" v-model="userdata.idNumber" :readonly="false"
									@change="propertyChanged" name="idNumber" v-validate="'required'"
									data-vv-as="idNumber"></el-input>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('idNumber') }}</span>
								</transition>
							</div>
						</div>

						<div class="row mt-12">
							<div class="col-md-6">
								<strong>Re-Upload Customer ID</strong>
								<!-- <el-input type="file" ref="file" v-on:change="handleIDFileUpload"  />	 -->
								<input type="file" ref="file" @change="handleIDFileUpload" />
							</div>
							<div class="col-md-6">
								<el-button type="warning" class="btn-group" style="width:30%"
									v-show="userPermissionsFilter.approveusers" @click="reUploadID">
									<i class="mdi mdi-account-check"></i><span> Upload ID</span>
								</el-button>
							</div>
						</div>



						<div class="row mt-12">
							<div class="col col-md-12">
								<strong>KYC Status</strong>
								<el-input placeholder="kycConfirmation" v-model="userdata.kycConfirmation"
									:readonly="readOnlyMode" @change="propertyChanged" name="kycConfirmation"
									v-validate="'required'" data-vv-as="kycConfirmation"></el-input>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('kycConfirmation') }}</span>
								</transition>
							</div>
						</div>
						<div class="row mt-12">
							<div class="col col-md-12">
								<strong>Document Expiry Date</strong>
								<el-date-picker style="width: 100%" v-model="userdata.expiryDate" type="date"
									format="yyyy-MM-dd" :picker-options="{ disabledDate: disableAllDatesBeforeToday }"
									placeholder="Document Expiry Date" name="expiryDate"
									data-vv-as="document expiry date"></el-date-picker>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('expiryDate') }}</span>
								</transition>
							</div>
						</div>

						<div class="row mt-12">
							<div class="col col-md-12">
								<strong>Failure Reason <span :class="required">*</span></strong>
								<el-select v-model="failureReason" filterable clearable placeholder="Failure Reason"
									class="mb-10" style="width:100%" name="failureReason" v-validate="'required'"
									data-vv-as="Failure Reason">
									<el-option v-for="failureR in failureReasons" :key="failureR" :label="failureR"
										:value="failureR"></el-option>
								</el-select>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('failureReason') }}</span>
								</transition>
							</div>
						</div>
						<div class="row mt-12">
							<div class="col col-md-12">
								<strong>Other KYC Comments <span :class="required">*</span></strong>
								<el-input placeholder="input your comment" v-model="userdata.kycComments"
									name="kycComments" v-validate="'required'" data-vv-as="kycComments"></el-input>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('kycComments') }}</span>
								</transition>
							</div>
						</div>
						<div class="row mt-12">
							<strong>ID /or Passport/ or Allien ID</strong>
							<div class="col col-md-12">
								<a data-magnify="gallery" :data-caption="userdata.fullName" :href="IdProfile">
									<img :src="IdProfile" alt="ID"
										style="max-height: 500px;height:auto;width: auto;max-width: 100%;">
								</a>
							</div>
						</div>

						<div class="row mt-12">
							<strong>Work Permit</strong>
							<div class="col col-md-12">
								<a data-magnify="gallery" :data-caption="userdata.fullName" :href="wrkPermit">
									<img :src="wrkPermit" alt="Work Permit"
										style="max-height: 500px;height:auto;width: auto;max-width: 100%;">
								</a>
							</div>
						</div>

						<div class="row mt-12">
							<strong>Special Pass</strong>
							<div class="col col-md-12">
								<a data-magnify="gallery" :data-caption="userdata.fullName" :href="specialPass">
									<img :src="specialPass" alt="Special Pass"
										style="max-height: 500px;height:auto;width: auto;max-width: 100%;">
								</a>
							</div>
						</div>


						<div class="row mt-12"
							v-show="userdata.id != null && userPermissionsFilter.viewuserscompliance">
							<div class="col col-md-12">
								<el-button type="warning" class="btn-group" style="width:30%"
									v-show="userPermissionsFilter.approveusers"
									@click="GoToUpdateUser(userdata.UserID, $event)">
									<i class="mdi mdi-account-check"></i><span> Update KYC</span>
								</el-button>
								<!-- <el-button type="warning" class="btn-group" style="width:30%" v-show="userPermissionsFilter.approveusers" @click="updateUserKyc">
											<i class="mdi mdi-account-check"></i><span> Update KYC</span>
										</el-button> -->
								<el-button type="danger" class="btn-group" style="width:30%"
									v-show="userPermissionsFilter.deleteuserkyc" @click="deleteUsersProfiles"><i
										class="mdi mdi-delete"></i><span> Delete</span></el-button>
								<el-button type="warning" class="btn-group" style="width:30%"
									v-show="userPermissionsFilter.rejectusers" @click="rejectUsersProfiles">
									<i class="mdi mdi-cancel"></i><span> Reject</span>
								</el-button>
								<el-button type="success" class="btn-group" style="width:30%"
									v-show="userPermissionsFilter.approveusers" @click="approveUsersProfiles">
									<i class="mdi mdi-account-check"></i><span> Approve</span>
								</el-button>
							</div>
						</div>
					</div>
				</div>
			</el-dialog>
		</div>
	</vue-scroll>
</template>

<script>
import PermissionsMixin from '@/mixins/PermissionsMixins'
import moment from 'moment'
import router from "@/router/";

export default {
	name: 'Users',
	data() {
		return {
			//mbuvi
			iDFile: '', //reupload id for customer
			IdFileData: new FormData(),

			//edited adata
			editedKycProfile: {
				userID: '',
				fullName: '',
				idNumber: '',
				phoneNumber: '',
				kycComments: ''
			},
			failureReasons: ["Wrong-Documents", "IPRS-Error", "Customer-Error", "System-Error"],
			search: '',
			pageWidth: 0,
			failureReason: '',
			userdata: '',
			imagePlaceholder: 'data:image/jpeg;base64,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'
		}
	},
	computed: {
		usersFiltered() {
			//console.log(this.users);
			return this.users.filter(({ firstName, lastName, email, phoneNumber, companyId }) => (firstName + lastName + email + phoneNumber).toString().toLowerCase().indexOf(this.search.toString().toLowerCase()) !== -1)
		},
		contactsClass() {
			return this.pageWidth >= 870 ? 'large' : this.pageWidth >= 760 ? 'medium' : 'small'
		},
		readOnlyMode() {
			return !this.userPermissionsFilter.addusers && !this.userPermissionsFilter.editusers;
		}
	},
	methods: {
		openDialog(data) {
			this.userdata = data
			this.editedKycProfile = data
			//alert(JSON.stringify(data))
			this.dialogFormVisible = true
			this.getIdPicture(this.userdata.userID);
			this.getWorkPermitPicture(this.userdata.userID);
			this.getSpecialpassPicture(this.userdata.userID);
		},
		GoToUpdateUser(id, $event) {
			router.push("/UsersComplianceView/" + id);
		},
		setPageWidth() {
			this.pageWidth = document.getElementById('page-contacts').offsetWidth
		},
		__resizeHanlder: _.throttle(function (e) {
			this.setPageWidth()
		}, 700),
		activateCurrentUser() {
			this.dialogFormVisible = false;
			this.lockout = true;
			this.activateUser(this.userdata.id, true)
				.then(result => {
					if (result) {
						this.successMessage('User has been activated.');
						this.getUsersProfiles();
					}
				})
				.catch(err => this.errorMessage('An error occured.'));
		},
		rejectUsersProfiles() {
			this.dialogFormVisible = false;
			this.disapproveUser(this.userdata.userID, this.failureReason)
				.then(result => {
					if (result) {
						this.successMessage('User has been Rejected.');
						this.getUsersProfiles();
					}
				})
				.catch(err => this.errorMessage('An error occured.'));
		},
		deleteUsersProfiles() {
			this.dialogFormVisible = false;
			if (confirm("Do you really want to delete?")) {
				this.deleteUserKYC(this.userdata.userID)
					.then(result => {
						if (result) {
							this.successMessage('User kyc has been Deleted.');
							this.getUsersProfiles();
						}
					})
					.catch(err => this.errorMessage('An error occured.'));
			}
		},
		approveUsersProfiles() {
			var newDate = moment(String(this.userdata.expiryDate)).format('DD-MM-YYYY');
			var self = this;
			this.$validator.validateAll().then((result) => {
				if (result) {
					if (!this.$validator.errors.has("userID") && !this.$validator.errors.has("kycComments") && !this.$validator.errors.has("failureReason")) {
						this.approveUser(this.userdata.userID, this.userdata.kycComments, newDate, this.failureReason)
							.then(result => {
								if (result) {
									this.dialogFormVisible = false;
									this.successMessage('User has been approved.');
									this.getUsersProfiles();
								}
							})
							.catch(err => this.errorMessage('An error occured.'));
					}
					else {
						alert("Kindly fill the required fields.");
					}
				}
			});
		},

		//mbuvi
		validateDate() {
			var dt = moment(String(this.userdata.expiryDate)).format('DD/MM/YYYY')
			var dateregex = /^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/
			if (!dateregex.test(dt)) {
				//show error
				this.errorMessage("bad date format, allowed format: dd/MM/yyyy")
				return
			}
		},
		updateUserKyc() {
			this.dialogFormVisible = false;
			var dt = moment(String(this.userdata.expiryDate)).format('DD/MM/YYYY')
			var dateregex = /^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/
			if (!dateregex.test(dt)) {
				//show error
				this.errorMessage("Bad date format!, Only allowed format: dd/MM/yyyy")
				return
			}
			else {

				// validate
				if (!this.$validator.errors.has('fullName') &&
					!this.$validator.errors.has('phoneNumber') &&
					!this.$validator.errors.has('idNumber') &&
					!this.$validator.errors.has('expiryDate') &&
					!this.$validator.errors.has('kycComments')) {
					this.$validator.reset();

					//now check nulls
					if (!this.editedKycProfile.fullName || !this.editedKycProfile.kycComments ||
						!this.editedKycProfile.phoneNumber || !this.editedKycProfile.idNumber ||
						!this.editedKycProfile.expiryDate) {
						this.errorMessage('Null fieldds detected, fill all the required input fields!')
						return
					}

					this.editUserKyc(this.editedKycProfile)
						.then(result => {
							if (result) {
								this.successMessage('User KYC edited successfully!');
							}
						}).catch(err => this.errorMessage('An error occured!'));

				}
				else {
					this.errorMessage('Form has some errors, check on the mandatory fields!')
				}
			}
		},

		updatePhoneNo() {
			this.editKycPhonenumber(this.editedKycProfile)
				.then(result => {
					if (result) {
						this.successMessage('User KYC edited successfully!');
					}
				}).catch(err => this.errorMessage('Error occured while updating phone number!'));
		},

		// file handler: mbuvi
		handleIDFileUpload() {
			this.iDFile = this.$refs.file.files[0];
		},

		//id image update
		reUploadID() {
			this.IdFileData.append('files', this.iDFile);
			this.IdFileData.append('userId', this.userdata.userID);

			this.uploadCustomerID(this.IdFileData)
				.then(result => {
					if (result) {
						this.successMessage('Customer ID updated Successfully!');
					}
				}).catch(err => this.errorMessage('Error occured while uploading the Customer ID!'));
		},

		deactivateUser() {
			this.dialogFormVisible = false;
			this.lockout = false;
			this.activateUser(this.userdata.id, false)
				.then(result => {
					if (result) {
						this.successMessage('User has been deactivated.');
						this.getUsersProfiles();
					}
				})
				.catch(err => this.errorMessage('An error occured.'));
		},
		companyChanged() {
			//this.fetchUsers();
			this.getUsersProfiles();
		},
		fetchUsers() {
			this.getUsersProfiles();
		},

		saveCurrentUser() {
			let self = this;
			if (!this.$validator.errors.has('firstname') &&
				!this.$validator.errors.has('lastname') &&
				!this.$validator.errors.has('email') &&
				!this.$validator.errors.has('phone')) {
				this.$validator.reset();
				this.saveUser(this.userdata)
					.then(result => {
						if (result.id.length > 0) {
							this.fetchUsers();
							this.successMessage('User saved successfully.');
						}
					})
					.catch(err => this.errorMessage('Failed to create user.'));
				this.dialogFormVisible = false;
			}
		},
		checkActive() {
			if (!this.readOnlyMode) {
				this.userdata.active = !this.userdata.active
			}
		},
		resendEmail() {
			this.reSendConfirmationEmail(this.userdata.id)
				.then(result => {
					if (result) {
						this.successMessage('Email sent.');
					}
					else {
						this.errorMessage('Email not sent');
					}
				})
				.catch(() => this.errorMessage('An error occured'));
		},
		lockUserAccount(lock) {
			var state = lock ? 'lock' : 'unlock';
			this.reSendConfirmationEmail(this.userdata.id, lock)
				.then(result => {
					if (result) {

						this.successMessage(`Account ${state}ed`);
					}
					else {
						this.errorMessage(`Failed to ${state} account`);
					}
				})
				.catch(() => this.errorMessage('An error occured'));
		}
	},
	mounted() {
		this.fetchUsers();
		this.getCompanyNames();
		this.setPageWidth()
	},
	created() {
		this.saveEvent = 'saveCurrentUser';
		this.$on(this.saveEvent, this.saveCurrentUser);
	},
	mixins: [PermissionsMixin]
}


</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables';
@import '../../assets/scss/_variables';
@import '../../assets/scss/dialogs';

.page-contacts {
	color: #fff;
	height: 100%;
	margin: 0 !important;
	padding: 20px;
	padding-bottom: 10px;
	box-sizing: border-box;

	.search-card {
		padding: 50px;
		max-width: 350px;
		max-height: 370px;
		box-sizing: border-box;
		margin-bottom: 15px;

		.el-input,
		.el-button {
			width: 100%;
		}
	}

	.search-wrap {
		margin: 0 auto;
		margin-bottom: 10px;
		padding: 0px 30px;
		box-sizing: border-box;
		width: 100%;
		max-width: 600px;

		i {
			display: inline-block;
			width: 22px;
		}

		input,
		select {
			outline: none;
			background: transparent;
			border: none;
			font-size: 15px;
			position: relative;
			top: -2px;
			width: 100%;
			padding: 0;
			color: $text-color;
		}

		.contacts-tot {
			margin-right: 20px;
			margin-left: 10px;
		}

		a {
			border-bottom: 1px solid;
			text-decoration: none;
			color: $text-color;

			&:hover {
				opacity: .6;
			}
		}
	}

	.contacts-root {
		max-height: 100%;
	}

	.contacts-list {
		//margin: 0 auto;
		width: 100%;
		max-width: 965px;
		padding: 0px 30px;
		box-sizing: border-box;

		.contact {
			margin: 10px 0;
			padding: 5px;
			box-sizing: border-box;
			cursor: pointer;
			transition: all .5s .25s;

			.star {
				.mdi-star {
					color: #ffd730;
				}

				.mdi-star-outline {
					opacity: .5;
				}
			}

			.avatar {
				width: 60px;
				transition: all .5s .25s;

				img {
					border: 1px solid transparentize($text-color, .9);
					box-sizing: border-box;
					width: 50px;
					height: 50px;
					border-radius: 50%;
					transition: all .5s .25s;
				}
			}

			.info {
				word-break: break-word;

				.name {

					//.fullname {}

					.email {
						opacity: 0;
						line-height: 0;
						transition: all .5s .25s;
					}

					.phone {
						display: none;
					}
				}

				//.phone {}
			}

			&:hover {
				margin: 15px -20px;
				padding: 10px;
				background-color: lighten($background-color, 20%);
				border-radius: 5px;
				box-shadow: 0 8px 16px 0 rgba(40, 40, 90, .09), 0 3px 6px 0 rgba(0, 0, 0, .065);

				.avatar {
					width: 90px;

					img {
						width: 90px;
						height: 90px;
					}
				}

				.info {
					.name {
						.email {
							opacity: 1;
							line-height: 1.4;
						}
					}
				}
			}
		}
	}

	.contacts-root {
		&.medium {
			.search-card {
				padding: 20px;
				max-width: 260px;
				max-height: 360px;
			}
		}

		&.small {
			overflow-y: auto;
			display: block;
			-webkit-box-orient: vertical;
			-webkit-box-direction: normal;
			-ms-flex-direction: column;
			flex-direction: column;
			padding: 5px;

			.search-card {
				padding: 20px;
				max-width: 100%;
				width: 100%;
				//max-height: 240px;
				flex: none;
				-webkit-box-flex: none;
				-ms-flex: none;
				display: block;
				overflow: hidden !important;
			}

			.contacts-list {
				flex: none;
				-webkit-box-flex: none;
				-ms-flex: none;
				display: block;
				overflow: hidden !important;
			}
		}
	}
}

@media (max-width: 768px) {
	.page-contacts {
		.search-wrap {
			padding: 0;
		}

		.contacts-list {
			padding: 0px;

			.contact {
				.avatar {
					width: 40px;

					img {
						width: 40px;
						height: 40px;
					}
				}

				.info {
					.phone {
						display: none;
					}

					.name {
						.phone {
							display: block;
						}
					}
				}

				&:hover {
					margin: 15px 0px;

					.avatar {
						width: 60px;

						img {
							width: 60px;
							height: 60px;
						}
					}
				}
			}
		}

		.contacts-root {
			&.medium {
				.contacts-list {
					padding: 0 30px;
				}
			}

			&.small {
				.contacts-list {
					padding: 8px;
				}
			}
		}
	}
}
</style>

<style>
.form-box .el-select {
	width: 100%;
}
</style>